import moment from 'moment';
import _ from 'lodash';

// Constants
import { SORTABLE_DATE_FORMAT, SORTABLE_TIME_FORMAT } from 'constants';

const urgencySortMap = {
  critical: 1,
  urgent: 2,
  planned: 3,
  normal: 4,
  pendingInput: 5,
  afterHours: 7
};

const dateUrgencySortMap = {
  critical: 2,
  urgent: 3,
  planned: 4,
  normal: 4,
  pendingInput: 4,
  afterHours: 4
};

export default class Task {
  // This class does not extend rest because there is no task controller. Always access tasks through their ticket

  static startsToday(task) {
    const taskStartDate = moment(task.startDate).startOf('day');
    const today = moment().startOf('day');
    return taskStartDate.isSame(today, 'day');
  }

  static isToday(task) {
    const taskDueDate = moment(task.dueDate).startOf('day');
    const today = moment().startOf('day');
    return taskDueDate.isSame(today, 'day');
  }

  static completedToday(task) {
    const taskCompleteDate = moment(task.completedAt).startOf('day');
    const today = moment().startOf('day');
    return taskCompleteDate.isSame(today, 'day');
  }

  static isOverdue(task) {
    const taskDueDate = moment(task.dueDate).startOf('day');
    const today = moment().startOf('day');
    return taskDueDate.isBefore(today, 'day');
  }

  static isStarted(task) {
    const taskStartDate = moment(task.startDate).startOf('day');
    const today = moment().startOf('day');
    return taskStartDate.isBefore(today, 'day');
  }

  static daysTilDue(task, date, raw) {
    const taskDueDate = moment(date || task.dueDate).startOf('day');
    const today = moment().startOf('day');
    const days = taskDueDate.startOf('d').diff(today, 'days');
    return raw ? days : Math.abs(days);
  }

  static daysTilStart(task, date, raw) {
    const taskStartDate = moment(date || task.startDate).startOf('day');
    const today = moment().startOf('day');
    const days = taskStartDate.startOf('d').diff(today, 'days');
    return raw ? days : Math.abs(days);
  }

  static daysToResolved(task) {
    const completedAt = moment(task.completedAt).startOf('day');
    const createdAt = moment(task.createdAt).startOf('day');
    return completedAt.diff(createdAt, 'days');
  }

  static urgency(task) {
    return _.kebabCase(task.priority);
  }

  static urgencySort(task) {
    return urgencySortMap[_.camelCase(task.priority)];
  }

  static dateUrgencySort(task) {
    // If the task is today sort by due date first
    if (moment(task.dueDate).isSameOrBefore(moment(), 'day')) return 1;

    return dateUrgencySortMap[_.camelCase(task.priority)];
  }

  static sort(unsorted, prioritizeCritical) {
    const sorters = [
      task => moment(task.dueDate).format(SORTABLE_DATE_FORMAT),
      task => Task.urgencySort(task),
      task => moment(task.createdAt).format(SORTABLE_TIME_FORMAT)
    ];

    const orders = ['asc', 'asc', 'desc'];

    if (prioritizeCritical) {
      sorters.unshift(task => Task.dateUrgencySort(task));
      orders.unshift('asc');
    }

    return _.orderBy(unsorted, sorters, orders);
  }

  static getSortKey(task) {
    const taskUrgency = Task.urgency(task);
    const dueDateString = moment(task.dueDate).format(SORTABLE_DATE_FORMAT);
    const createdAtString = moment(task.createdAt).format(SORTABLE_TIME_FORMAT);
    if (taskUrgency === 'high') return `${dueDateString}-1-${createdAtString}`;
    if (taskUrgency === 'normal') return `${dueDateString}-2-${createdAtString}`;
    if (taskUrgency === 'low') return `${dueDateString}-3-${createdAtString}`;

    return `${dueDateString}-4-${createdAtString}`;
  }
}
